<template>
  <!-- <div> -->
    <button class="btn" @click="click()">{{ displayLabel }}</button>
    <!-- <button v-if="false" class="btn" @click="click()">{{ displayLabel }}</button> -->
  <!-- </div> -->
</template>

<script>

export default {
    name: 'Button-Doublecheck',
    props: {
        label: { type: String, required: true },
        label2: { type: String, default: 'Sure?' },
        timeout: { type: Number, default: 2000 }
    },
    data () {
      return {
        confirm: false
      }
    },
    computed: {
      displayLabel () {
        return !this.confirm ? this.label : this.label2
      }
    },
    methods: {
      click (event) {
        if (this.confirm) {
          this.$emit(`click`)
          this.confirm = false
        }
        else {
          this.confirm = true
          setTimeout(() => this.confirm = false, this.timeout)
        }
      }
    }

}
</script>

<style>

</style>